'use client'
import { usePathname } from 'next/navigation'
import React, { useEffect, useState } from 'react'
import type { Header } from '@/payload-types'
import { HeaderNav } from './Nav'
import { cn } from '@/utilities/cn'
import { RenderBlocks } from '@/blocks/RenderBlocks'

interface HeaderClientProps {
  header: Header
  draftMode: boolean
  darkMode: boolean
}

export const HeaderClient: React.FC<HeaderClientProps> = ({
  header,
  draftMode,
  darkMode = false,
}) => {
  const pathname = usePathname()

  // State to manage shadow visibility
  const [showShadow, setShowShadow] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      // Check if scroll is past 1/4 screen height
      const scrollThreshold = window.innerHeight / 4
      if (window.scrollY > scrollThreshold) {
        setShowShadow(true)
      } else {
        setShowShadow(false)
      }
    }

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll)

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div>
      <header
        className={cn(
          'fixed left-0 top-0 w-full z-20 transition-shadow duration-1000',
          showShadow ? 'shadow-lg' : 'shadow-none',
        )}
        data-theme={darkMode ? 'dark' : 'light'}
      >
        {header.beforeHeader && <RenderBlocks blocks={header.beforeHeader}/>}
        <HeaderNav header={header} />
      </header>
    </div>
  )
}
